/*
  Phantasmagorical: buy-more-save-more note.
  Shows "Buy 2 save 10% · Buy 3+ save 15%" on the PDP (near the buy box) and in the
  cart/drawer (under the free-shipping bar) so warm shoppers see the automatic
  quantity discount. Upgrade-safe: loaded via theme-globals.liquid, self-contained.
*/
(function () {
  'use strict';
  if (window.__pgVolNoteInstalled) return;
  window.__pgVolNoteInstalled = true;

  var CSS = '.pg-vol-note{display:flex;align-items:center;gap:8px;font-size:.8rem;letter-spacing:.5px;color:var(--pg-text,#E0E0E0);border:1px solid rgba(62,224,207,.35);border-radius:2px;padding:8px 12px;background:rgba(62,224,207,.06);line-height:1.3}'
    + '.pg-vol-note__icon{color:var(--pg-cyan,#3EE0CF);font-size:.7rem;flex:0 0 auto}'
    + '.pg-vol-note__text strong{color:var(--pg-cyan,#3EE0CF);font-weight:600}'
    + '.pg-vol-note--pdp{margin:14px 0}.pg-vol-note--cart{margin:12px 0 4px}';

  function injectStyle(){
    if (document.getElementById('pg-vol-note-style')) return;
    var s = document.createElement('style');
    s.id = 'pg-vol-note-style';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function makeNote(variant){
    var el = document.createElement('div');
    el.className = 'pg-vol-note pg-vol-note--' + variant;
    el.setAttribute('data-pg-vol-note', variant);
    el.innerHTML = '<span class="pg-vol-note__icon" aria-hidden="true">◆</span>'
      + '<span class="pg-vol-note__text">Buy <strong>2</strong>, save <strong>10%</strong> · Buy <strong>3+</strong>, save <strong>15%</strong></span>';
    return el;
  }

  function injectPDP(){
    if (document.querySelector('[data-pg-vol-note="pdp"]')) return;
    var form = document.querySelector('[data-product-form]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var atc = form.querySelector('.product-form__submit') || form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]');
    if (!atc) return;
    var holder = atc.closest('.product-form__submit-holder') || atc;
    holder.parentNode.insertBefore(makeNote('pdp'), holder);
  }

  function injectCart(){
    var bars = document.querySelectorAll('.free-shipping-bar');
    for (var i = 0; i < bars.length; i++){
      var bar = bars[i];
      if (bar.parentNode.querySelector('[data-pg-vol-note="cart"]')) continue;
      bar.parentNode.insertBefore(makeNote('cart'), bar.nextSibling);
    }
  }

  function run(){
    injectStyle();
    if (document.body && document.body.classList.contains('template-product')) injectPDP();
    injectCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  try {
    var mo = new MutationObserver(function (muts){
      for (var i = 0; i < muts.length; i++){
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++){
          var n = added[j];
          if (n.nodeType === 1 && ((n.matches && n.matches('.free-shipping-bar')) || (n.querySelector && n.querySelector('.free-shipping-bar')))){
            injectCart();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
